module.exports = __webpack_public_path__ + "img/video-pic01.3b70fbc6.jpg";